import React from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";

import { TScoreData } from "../../../../../../common/types";
import { editTask } from "../../../../../store/plan/actions";
import { post } from "../../../../../actions/general";
import Icon from "../../../../../icon";
import { Changer, ChangerPopup } from "../../../EditorBar";
import { Range } from "../../../../Form";
import getTempo from "../getTempo";

import { IProps } from "./interfaces";
import messages from "./messages";

const ChangeTempo = ({ openChanger, handleChangeOpen, plan, taskIndex, setPopupRef }: IProps) => {
    const task = plan.tasks[taskIndex];
    const dispatch = useDispatch();
    const changeTempo = (val: number) => {
        dispatch(editTask({ taskIndex, changingProp: "tempo", val }));
    };

    const changeTempoStop = () => {
        const { tempo = 60 } = plan.tasks[taskIndex].data as TScoreData;
        dispatch(post("task-tempo", {
            planId: plan._id,
            index: taskIndex,
            tempo,
        }));
    };
    return (
        <Changer active={openChanger === "tempo"}>
            <div
                onClick={e => {
                    e.stopPropagation();
                    handleChangeOpen("tempo");
                }}
            >
                <Icon i="metronome" /> <i>{getTempo(plan, task)}</i>
            </div>
            {openChanger === "tempo" && (
                <ChangerPopup setRef={setPopupRef} onRight>
                    <Range
                        scale={1}
                        value={getTempo(plan, task)}
                        onChange={changeTempo}
                        onStop={changeTempoStop}
                        min={32}
                        max={240}
                        step={2}
                        label={<FormattedMessage {...messages.tempo} />}
                    />
                </ChangerPopup>
            )}
        </Changer>
    );
};

export default ChangeTempo;
